<template>
    <div class="e-penalty-option-market">
        <div class="e-penalty-option-market-title">
            {{ title }}
        </div>
        <div
            v-for="odds in oddsList"
            v-bind:key="odds.oddsId"
            class="e-penalty-option-market-options"
        >
            <OptionOdds
                v-for="priceOption in odds.priceOption"
                v-bind:key="`${odds.oddsId}:${priceOption.option}`"
                v-bind:oddsInfo="odds"
                v-bind:priceOption="priceOption"
                v-bind:matchInfo="match"
                v-bind:marketOrder="marketOrder"
                class="e-penalty-option-market-odds"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { type PropType, computed } from 'vue';
    import OptionOdds from '@/components/match/OptionOdds.vue';
    import type { IMatch } from '@/interface/IMatch';
    import type { IOdds } from '@/interface/IOdds';
    import { BetTypeGroup } from '@/interface/enum';
    import { getTranslated } from '@/libraries/helpers/translationHelper';
    import { i18n } from '@/libraries/i18n';

    const props = defineProps({
        match: {
            type: Object as PropType<IMatch>,
            required: true,
        },
        oddsList: {
            type: Array as PropType<IOdds[]>,
            required: true,
        },
        marketOrder: {
            type: Number,
            default: -1,
        },
    });

    const ePenaltyMarketGroups = [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick];

    const title = computed(() => {
        const [firstOdds] = props.oddsList;
        const marketTypeName = i18n.t(firstOdds.marketDisplayTypeName);
        return ePenaltyMarketGroups.includes(firstOdds.marketGroup.id)
            ? marketTypeName
            : `${getTranslated(firstOdds.marketGroup.name)} - ${marketTypeName}`;
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/odd";
@import "@/scss/components/ePenalty/ePenaltyOptionMarket";
</style>
